export var MemberFormFieldName;
(function (MemberFormFieldName) {
    MemberFormFieldName["Address"] = "Address";
    MemberFormFieldName["City"] = "City";
    MemberFormFieldName["DateOfBirth"] = "DateOfBirth";
    MemberFormFieldName["ExternalId"] = "ExternalId";
    MemberFormFieldName["FamilyName"] = "FamilyName";
    MemberFormFieldName["PrimarySite"] = "PrimarySite";
    MemberFormFieldName["FavouriteGenres"] = "FavouriteGenres";
    MemberFormFieldName["Gender"] = "Gender";
    MemberFormFieldName["GivenName"] = "GivenName";
    MemberFormFieldName["HomeNumber"] = "HomeNumber";
    MemberFormFieldName["MobileNumber"] = "MobileNumber";
    MemberFormFieldName["NationalId"] = "NationalId";
    MemberFormFieldName["Newsletter"] = "Newsletter";
    MemberFormFieldName["PostCode"] = "PostCode";
    MemberFormFieldName["Captcha"] = "Captcha";
    MemberFormFieldName["State"] = "State";
    MemberFormFieldName["Suburb"] = "Suburb";
    MemberFormFieldName["TermsAndConditions"] = "TermsAndConditions";
    MemberFormFieldName["AllowThirdPartyProfiling"] = "AllowThirdPartyProfiling";
    MemberFormFieldName["AllowThirdPartyContact"] = "AllowThirdPartyContact";
})(MemberFormFieldName || (MemberFormFieldName = {}));
